import { Box, Button, Card, Typography, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';

// motion.create() is the current factory; motion(Component) is deprecated in v12.
export const MotionBox = motion.create(Box);
export const MotionCard = motion.create(Card);
export const MotionTypography = motion.create(Typography);
export const MotionButton = motion.create(Button);

// Expressive easing curve, used everywhere so motion feels like one system.
const EASE = [0.22, 1, 0.36, 1];

export const fadeInUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE, delay } }
});

export const slideIn = (direction, delay = 0) => ({
  hidden: {
    opacity: 0,
    x: direction === 'left' ? -60 : direction === 'right' ? 60 : 0,
    y: direction === 'up' ? 60 : direction === 'down' ? -60 : 0
  },
  visible: { opacity: 1, x: 0, y: 0, transition: { duration: 0.7, ease: EASE, delay } }
});

export const useReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)');

/**
 * Returns a builder for scroll-triggered animation props. When the user prefers
 * reduced motion it returns nothing, so content renders in its final state.
 */
export const useMotionProps = () => {
  const reduced = useReducedMotion();
  return (variants) =>
    reduced
      ? {}
      : {
          initial: 'hidden',
          whileInView: 'visible',
          viewport: { once: true, margin: '-80px' },
          variants
        };
};
